import Home from "../../views/Home";
import Presentation from "../../views/Presentation";
import Orari from "../../views/Orari";
import Notifiche from "../../views/Notifiche";
import Impostazioni from "../../views/Impostazioni";
import NewsIndex from "../../views/news/Index";
import NewsList from "../../views/news/List";
import NewsDetails from "../../views/news/Details";
import Fidelity from "../../views/fidelity/Index";

export default [
    {
        path: '/',
        name: 'home',
        component: Home,
        meta: {
            showNav: true,
            showOptionbar: true,
            showLogo: true
        }
    },
    {
        path: '/presentazione',
        name: 'presentation',
        component: Presentation,
        meta: {
            showNav: true,
            showOptionbar: true,
            headerTitleKey: 'layout_info'
        }
    },
    {
        path: '/orari',
        name: 'orari',
        component: Orari,
        meta: {
            showNav: true,
            showOptionbar: true,
            headerTitleKey: 'layout_orari'
        }
    },
    {
        path: '/notifiche',
        name: 'notifiche',
        component: Notifiche,
        meta: {
            showNav: true,
            showOptionbar: true,
            headerTitleKey: 'layout_notifiche'
        }
    },
    {
        path: '/impostazioni',
        name: 'impostazioni',
        component: Impostazioni,
        meta: {
            showNav: true,
            showOptionbar: true,
            headerTitleKey: 'layout_impostazioni'
        }
    },
    {
        path: '/news',
        component: NewsIndex,
        children: [
            {
                path: '',
                name: 'news.list',
                component: NewsList,
                meta: {
                    showNav: true,
                    showOptionbar: true,
                    headerTitleKey: 'layout_news'
                }
            },
            {
                path: 'dettaglio/:id',
                name: 'news.details',
                component: NewsDetails,
                meta: {
                    showNav: true,
                    showOptionbar: true,
                    headerTitleKey: 'layout_news'
                }
            }
        ]
    },
    {
        path: '/fidelity',
        name: 'fidelity',
        component: Fidelity,
        meta: {
            showNav: true,
            showOptionbar: true,
            headerTitleKey: 'layout_fidelity_card'
        }
    }
]
